// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RequirePermission } from "@/components/shared/require-permission";
import { TasksList } from "@/features/tasks/tasks-list";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/tasks/")({
  validateSearch: z.object({ f: z.string().optional() }),
  component: () => (
    <RequirePermission permission={PAGE_PERMISSIONS.tasks}>
      <TasksList />
    </RequirePermission>
  ),
});
